import { useMemo } from 'react';

// Get a stable URL of blob
export const useBlobURL = (blob?: Blob) => {
  return useMemo(() => (blob ? URL.createObjectURL(blob) : undefined), [blob]);
};
